import React from 'react';
import './FloatingMapButton.css';
import MapIcon from '@mui/icons-material/Map';
import { useNavigate } from 'react-router-dom';

const FloatingMapButton = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/mapUsert');
  };

  return (
    <button className="floating-map-btn" onClick={handleClick}>
      <MapIcon style={{ fontSize: 20 }} />
      <span>Mostrar mapa</span>
    </button>
  );
};

export default FloatingMapButton;
